import * as React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from "@expo/vector-icons";
import { AuthContext } from "../../contexts/auth/Store";
import Colors from "../../constants/Colors";
import { useNavigation, useRoute } from "@react-navigation/native";
import StyledIcon from "../StyledIcon";
import FontStyles from "../../constants/FontStyle";
import HeaderGradient from "./HeaderGradient";
import ChatButton from "../common/ChatButton";
import NotificationButton from "../common/NotificationButton";

interface IProps {
  title: string;
  textColor?: string;
  bgColor?: string;
  backAction?: Function;
  hideBackButton?: boolean;
}

const GenericHeader: React.FC<IProps> = function ({
  title,
  textColor,
  bgColor,
  backAction,
  hideBackButton,
}) {
  const auth = React.useContext(AuthContext);
  const navigation = useNavigation();
  const route = useRoute();

  const backButtonHandler = () => {
    if (backAction && typeof backAction === "function") {
      backAction();
      // return true
    } else {
      navigation.navigate("Home");
    }
    return true; // allow this function to handle navigation
  };

  React.useEffect(() => {
    return () => {
      //
    };
  }, []);

  return (
    <HeaderGradient>
      <View
        style={[
          styles.container,
          {
            backgroundColor: bgColor || "transparent",
          },
        ]}
      >
        {!hideBackButton && (
          <TouchableOpacity
            style={{
              padding: 8,
              marginLeft: -8,
              alignSelf: "center",
            }}
            onPress={backButtonHandler}
          >
            <StyledIcon
              iconName="md-arrow-back"
              iconColor={textColor || Colors.whiteColor}
              size={24}
              iconOnly
            />
          </TouchableOpacity>
        )}

        <View style={styles.topBar}>
          <View
            style={{
              flexShrink: 1,
              alignSelf: "center",
            }}
          >
            <Text
              style={[
                FontStyles.bold,
                FontStyles.size17,
                FontStyles.lh20,
                {
                  color: textColor || Colors.whiteColor,
                  textAlignVertical: "center",
                  textAlign: "left",
                  marginRight: 10,
                },
              ]}
              numberOfLines={1}
            >
              {title || route.name}
            </Text>
          </View>
          <View
            style={{
              flexDirection: "row",
              flexGrow: 1,
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <ChatButton />
            <NotificationButton />
          </View>
        </View>
      </View>
    </HeaderGradient>
  );
};

export default GenericHeader;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    paddingHorizontal: 16,
  },
  topBar: {
    flex: 1,
    flexDirection: "row",
    paddingVertical: 18,
  },
});
